import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectedPreferencesComponent} from './selected-preferences.component';

@NgModule({
    imports: [CommonModule],
    exports: [SelectedPreferencesComponent],
    declarations: [SelectedPreferencesComponent]
})
export class SelectedPreferencesModule {
}